import { styled as n } from "@mui/material";
const i = n("div")(({ theme: n2 }) => `
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: ${n2.spacing(2)};
`), e = n("div")(({ theme: n2 }) => `
  display: flex;
  flex-direction: column;
  gap: ${n2.spacing(2)};
  grid-column-start: 2;
  grid-column-end: 4;
`);
export {
  i as Grid,
  e as Wrapper
};
//# sourceMappingURL=styled.js.map
